// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2gI01","info":"Note_info__2tSEM","note":"Note_note__2SXGy","actions":"Note_actions__2KJdC"};